// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__-9eVi","title":"Projects_title__tBYLF","projects":"Projects_projects__Mqq8x"};